<template>
  <div class="footer-wrap">
    <p class="title">
      当前学习进度
      <a-button
        type="primary"
        class="ant-btn-secondary"
        :disabled="ProgressLoading || [0, -1].includes(giveLessonState)"
        @click="reload"
        style="margin-left: 12px;"
      >
        刷新
      </a-button>
    </p>
    <a-spin :spinning="ProgressLoading">
      <div style="min-height: 102px;">
        <p class="empty" v-if="tagList.length === 0 && !ProgressLoading">
          暂无数据
        </p>

        <ul class="card-list" v-else :class="[flexStart ? 'flex-start' : 'flex-center']">
          <li class="card" v-for="(item, i) in tagList" :key="i">
            <p class="course-name">
              {{ item.name || '--' }}
            </p>
            <div class="progress-wrap">
              <div class="progress" />
              <div class="des">
                <span>已学完{{ item.pushDownNum }}/{{ item.pushIngNum }}人</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </a-spin>
  </div>
</template>

<script>
export default {
  name: 'GiveInstructionFooter',

  props: {
    // 授课状态：0结束授课，1授课中
    giveLessonState: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      ProgressLoading: false,
      tagList: [],
      setInter25: null
    }
  },

  // created() {
  //   for (let i = 0; i < 25; i++) {
  //     this.tagList.push({
  //       name: '22222222222222222222222',
  //       pushDownNum: '1',
  //       pushIngNum: '1'
  //     })
  //   }
  // },

  watch: {
    giveLessonState(v) {
      v === 1 ? this.loop25s() : this.clearLoop25s()
    }
  },

  beforeDestroy() {
    this.clearLoop25s()
  },

  computed: {
    flexStart() {
      const w = Math.round(window.innerWidth - 271 - 50)
      const average = Math.round(w / this.tagList.length)
      console.log('average', average)
      return average < 180
    }
  },

  methods: {
    loop25s() {
      this.initProgress()
      // 授课状态：0结束授课，1授课中,只有授课中的轮询
      if (this.giveLessonState === 1) {
        this.setInter25 = setInterval(() => {
          this.initProgress()
        }, 25 * 1000)
      }
    },
    reload() {
      this.clearLoop25s()
      this.loop25s()
    },
    clearListAndLoop() {
      this.tagList = []
      this.clearLoop25s()
    },
    clearLoop25s() {
      clearInterval(this.setInter25)
      this.setInter25 = null
    },
    initProgress() {
      const { xkhTeacherCourseId, classTypeId, lessonId, aiLessonId } = this.$route.query
      this.ProgressLoading = true
      this.$service.giveInstruction.lessonPushNumber({
        xkhTeacherCourseId: Number(xkhTeacherCourseId),
        classTypeId: Number(classTypeId),
        lessonId: Number(lessonId),
        aiLessonId: Number(aiLessonId)
      }).then(res => {
        this.tagList = res
      }).catch(err => {
      }).finally(() => {
        this.ProgressLoading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.footer-wrap {
    width: 100%;
    height: auto;
    background: #fff;
    .title {
        height: 44px;
        background: #F5F7F9;
        font-family: 'Microsoft YaHei UI';
        font-weight: 700;
        font-size: 14px;
        line-height: 44px;
        letter-spacing: 0.06em;
        color: #70788C;
        padding: 0 20px;
    }
    .empty {
        height: 102px;
        line-height: 102px;
        width: 100%;
        text-align: center;
        font-size: 14px;
        letter-spacing: 0.04em;
        color: #505873;
    }
    .flex-start {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
    .flex-center {
      display: flex;
      overflow-x: scroll;
      overflow: overlay !important;
      justify-content: center;
    }
    .card-list {
        padding: 0;
        width: 100%;
        margin: 0;
        padding: 12px 20px 0 20px;
        .card {
            width: 169px;
            height: 78px;
            padding: 12px 16px;
            border: 1px solid #EBEDF0;
            border-radius: 12px;
            margin-right: 12px;
            margin-bottom: 12px;
            .course-name {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-family: 'Microsoft YaHei UI';
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                letter-spacing: 0.04em;
                color: #505873;
                margin-bottom: 4px;
            }
            .progress-wrap {
                position: relative;
                .progress {
                    border-radius: 8px;
                    height: 28px;
                    background-color: #DFE2E6;
                }
                .des {
                    position: absolute;
                    top: 4px;
                    left: 4px;
                    font-family: 'Microsoft YaHei UI';
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 20px;
                    display: flex;
                    align-items: center;
                    letter-spacing: 0.04em;
                    color: #303858;
                }
            }
        }
    }
}
</style>
